<template>
  <div class="card">
    <div class="card-title">{{ groupTitle }}</div>
    <div class="configuration">
      <div class="config-item" v-for="(key, n) in itemKeys" :key="n">
        <label><span>{{ getConfig(key).label }}</span>&nbsp;<i>-- {{ key }}</i></label>
        <!--div>{{ $settings.get(key) }}</div-->
        <dropdown  v-if="getConfig(key).type === 'dropdown'" :values="getConfig(key).values" :settingKey="key"></dropdown>
        <input-integer v-if="getConfig(key).type === 'integer'" :unit="getConfig(key).unit" :settingKey="key" :extra="getConfig(key).extra"></input-integer>
        <input-string v-if="getConfig(key).type === 'string'" :unit="getConfig(key).unit" :settingKey="key"></input-string>
        <radio-boolean v-if="getConfig(key).type === 'boolean'" :settingKey="key"></radio-boolean>
        <pickup-time-offsets v-if="getConfig(key).type === 'pickuptime-offsets'" :settingKey="key"></pickup-time-offsets>
        <div v-if="getConfig(key).type === 'discountField'" class="d-flex dc-field align-start">
          <dropdown  v-if="getConfig(key).fields.type" :values="getConfig(key).fields.type.values" :settingKey="getConfig(key).fields.type.id" class="dc-type"></dropdown>
          <input-integer v-if="getConfig(key).fields.amount" :settingKey="getConfig(key).fields.amount.id" unit="" removeMT="true"></input-integer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsConfig from './settings-config/index'

import Dropdown from './controls/Dropdown'
import InputInteger from './controls/InputInteger'
import InputString from './controls/InputString'
import RadioBoolean from './controls/RadioBoolean'
import PickupTimeOffsets from './controls/PickupTimeOffsets'

export default {
  name: 'settings-group',
  props: [ 'groupKey', 'groupTitle', 'itemKeys', 'column' ],
  components: { Dropdown, InputString, InputInteger, RadioBoolean, PickupTimeOffsets },
  methods: {
    getConfig (key) {
      return SettingsConfig[this.column][this.groupKey].items[key]
    }
  }
}
</script>

<style lang="scss" scoped>
.card{
  padding: 15px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.card-title{
  font-weight: 700;
  font-size: 12px;
  color: #0D79F2
}

.config-item {
  padding: 5px 0 10px;
  & label {
    font-size: 12px;
    font-weight: 700;
    color: #555;

    & i { font-weight: 400; }
  }

  &:not(:first-child) {
    margin-top: 5px;
    border-top: 1px solid rgba(0,0,0,0.1);
  }
}

.dc-field{
  gap: 5px;

  .dc-type{
    width: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/SettingsGroup.vue